import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { InscriptionService } from 'src/app/services/inscription.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inscription-item',
  templateUrl: './inscription-item.component.html',
  styleUrls: ['./inscription-item.component.scss'],
})
export class InscriptionItemComponent implements OnInit {
  @ViewChild('infiteScroll') infiteScroll: InfiniteScroll;
  @Output() openInscriptionEmitter = new EventEmitter();
  public testImg = environment.defaultImg;
  public inscriptions: any[] = [];
  public loaded = false;
  public noSubscriptionsMsg = '';
  private _page = 1;
  private _totalPages = 1;

  constructor(
    private httpSv: HttpService,
    private translateSv: TranslateService,
    private inscriptionSv: InscriptionService,
    private _paramSv: ParamServicesService
  ) {}

  async ngOnInit() {
    this.inscriptionSv.emitReload.subscribe(async () => {
      this.inscriptions = [];
      await this.setDefault();
    });
    await this.setDefault();
  }

  async setDefault() {
    this._page = 1;
    await this.getSubscriptions();
    this.loaded = true;
    this.infiteScroll?.setVisible();
    this.infiteScroll?.observe();
  }

  async getSubscriptions() {
    try {
      const param = { pag: this._page };
      const res = await this.httpSv.itemIndex('client/inscription', '', param);
      const data = res.data;
      this._totalPages = data.meta.last_page;
      this.inscriptions.push(...data.data);
      if (!this.inscriptions.length) {
        const existModule = this._paramSv.modulesNames.find(
          (x) => x.name === 'Suscripciones'
        );
        const msg = this.translateSv.instant(
          'NO_TIENES_SUSCRIPCIONES_ACTIVAS',
          {
            suscriptionName: existModule
              ? existModule.newName.toLowerCase()
              : 'suscripciones',
          }
        );
        this.noSubscriptionsMsg = msg;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async openInscription(inscription) {
    inscription.subscription.status = inscription.status;
    inscription.subscription.renovation = inscription.renovation;
    inscription.subscription.inscriptionId = inscription.id;
    inscription.subscription.autoRenovation = inscription.autoRenovation;
    inscription.subscription.isSuspended = inscription.isSuspended;
    inscription.subscription.remainingDues = inscription.remainingDues;
    this.openInscriptionEmitter.emit(inscription.subscription);
  }

  async loadData(ev: InfiniteScroll) {
    ev.disconnect();
    if (this._totalPages === this._page) {
      ev.complete();
      return true;
    } else {
      this._page++;
    }
    await this.getSubscriptions();
    ev.observe();
  }
}
